<template>

    <!-- Common Banner Area -->
    <HotelDetailBanner />

    <!-- Hotel Search Areas -->
    <HotelSearch />
</template>
<script>
import HotelDetailBanner from '@/components/hotel/HotelDetailBanner.vue'
import HotelSearch from '@/components/hotel/HotelSearch.vue'

export default {
    name: "HotelDetailsView",
    components: {
        HotelDetailBanner, HotelSearch
    }
};
</script>
